const TRACK = {
  typename: "Track",
  filterName: "track",
  urlParamId: "trackId",
  urlParamName: "track",
  displayName: "Track",
  iconName: "track",
  getFirstTrackId: e => e?.id,
  getQueueTracks: e => (e ? [e] : [])
};

const ALBUM = {
  typename: "Album",
  filterName: "session",
  urlParamId: "albumId",
  urlParamName: "album",
  displayName: "Session",
  iconName: "album",
  getFirstTrackId: e => e?.tracks?.[0]?.id,
  getQueueTracks: e => e?.tracks ?? []
};

const PLAYLIST = {
  typename: "Playlist",
  filterName: "playlist",
  urlParamId: "playlistId",
  urlParamName: "playlist",
  displayName: "Collection",
  iconName: "collection",
  getFirstTrackId: e => e?.playlistTracks?.[0]?.tracks?.id,
  getQueueTracks: e => (e?.playlistTracks ?? []).map(pt => pt.tracks)
};

export const getTrackEntityDisplayName = track =>
  track?.variationTitle
    ? [track.title, track.variationTitle].filter(Boolean).join(" | ")
    : track?.title || track?.name;

export const ENTITY_TYPES = [TRACK, ALBUM, PLAYLIST];

export const ENTITY_BY_TYPENAME = Object.fromEntries(
  ENTITY_TYPES.map(e => [e.typename, e])
);

export const ENTITY_BY_FILTER_NAME = Object.fromEntries(
  ENTITY_TYPES.map(e => [e.filterName, e])
);

export const ENTITY_FILTER_NAMES = ENTITY_TYPES.map(e => e.filterName);
export const ENTITY_URL_PARAM_IDS = ENTITY_TYPES.map(e => e.urlParamId);
export const ENTITY_URL_PARAM_NAMES = ENTITY_TYPES.map(e => e.urlParamName);

// allow either entity UUIDs OR entity names to render entity view
// for playlist, track, and album
export const ENTITY_URL_PARAMS = [
  ...ENTITY_URL_PARAM_IDS,
  ...ENTITY_URL_PARAM_NAMES
];
